<div class="current-payment-agreement justify-content-center h-100">
    <div class="content h-100"> 
        <div class="content-icon">
            <i class="icon-edponline-Bra-141 custom-icon"></i>
        </div>  

        <p class="title"> 
            {{ "pt.edp.edponline.current.payment.agreement.title" | translate }}  
        </p> 
        <p class="description">
            {{ "pt.edp.edponline.current.payment.agreement.description" | translate }}  
        </p>        

        <div class="custom-buttons">
            <div> 
                <button class="custom-button" [innerHtml]="'pt.edp.edponline.current.payment.agreement.button' | translate" (click)="onAgreementGenerate()"></button>
            </div>
        </div>

    </div>
</div>